import { useCallback } from 'react';
import type { ExportToGoogleSheetArgs } from '../../../infrastructure/BatchClient';
import { BatchClient } from '../../../infrastructure/BatchClient';
import { getConfig } from '../../../config';
import type { CompetitorProductSearchResult } from '../../../infrastructure/CompetitorClient';
import { CompetitorClient } from '../../../infrastructure/CompetitorClient';
import type { Competitor } from '../../../models/ProductTypes';

export const useCompetitor = () => {
  const config = getConfig();
  const batchClient = new BatchClient(config.apiUrl);
  const competitorClient = new CompetitorClient();

  const startAIMatchJob = useCallback(async (): Promise<void> => {
    try {
      await batchClient.triggerAIMatchBatchJob();
    } catch (error) {
      console.error('Failed to start AI match job:', error);
    }
  }, [batchClient]);

  const exportToGoogleSheet = useCallback(async (): Promise<void> => {
    try {
      const args: ExportToGoogleSheetArgs = {
        sheetId: config.sheetId,
        sheetName: 'SKUMatching',
      };
      await batchClient.triggerExportToGoogleSheetJob(args);
    } catch (error) {
      console.error('Failed to export to Google Sheet:', error);
    }
  }, [batchClient, config.sheetId]);

  const searchCompetitorProducts = useCallback(
    async (competitor: Competitor, term: string): Promise<CompetitorProductSearchResult> => {
      try {
        return await competitorClient.searchCompetitorProducts(competitor, term);
      } catch (error) {
        console.error('Error searching competitor products:', error);
        throw error;
      }
    },
    [competitorClient],
  );

  return {
    startAIMatchJob,
    exportToGoogleSheet,
    searchCompetitorProducts,
  };
};
